/**
 * Cliente HTTP do portal.
 *
 * A implementacao mora em `@fa/ui`, compartilhada com o backoffice: quando a
 * operacao atende um cliente, ela usa as mesmas telas e precisa do mesmo
 * cliente, inclusive do envio de arquivo que faltava la.
 */
import { API_URL, criarClienteHttp } from '@fa/ui';

export { ApiError, type ProblemBody } from '@fa/ui';

const cliente = criarClienteHttp({ baseUrl: API_URL, tokenKey: 'fa.portal.token' });

export const { getToken, setToken, api, apiForm, apiDownload, openDocumentFile } = cliente;
